'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _axios = require('axios');
var _axios2 = _interopRequireDefault(_axios);
var _request = require('./request');
var _request2 = _interopRequireDefault(_request);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
exports.default = function (domain) {
  var errorMessage = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'Please enter a valid email';
  return function (value, values) {
    return (0, _request2.default)(function (value) {
      return _axios2.default.post(process.env.REACT_APP_API_BASE_URI + '/shared/v1/validators/mx-validator', {
        email: value
      });
    }, errorMessage)(value, values);
  };
};